"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Autocomplete = _interopRequireWildcard(require("@material-ui/lab/Autocomplete"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _ListItemText = _interopRequireDefault(require("@eig-builder/core-ui/ListItemText"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex: 0 0 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var filter = (0, _Autocomplete.createFilterOptions)();
var FullWidthAutocomplete = (0, _styledComponents["default"])(_Autocomplete["default"])(_templateObject());

var NewAutocomplete = function NewAutocomplete(_ref) {
  var fieldConfiguration = _ref.fieldConfiguration,
      dataElementSuffix = _ref.dataElementSuffix,
      handleOnAddNew = _ref.handleOnAddNew,
      addNewItemtext = _ref.addNewItemtext,
      addNewCompare = _ref.addNewCompare,
      addNewValidator = _ref.addNewValidator,
      label = _ref.label,
      multiSelect = _ref.multiSelect,
      noItemFoundText = _ref.noItemFoundText,
      onSelectionChange = _ref.onSelectionChange,
      placeholder = _ref.placeholder,
      required = _ref.required,
      selectedSuggestions = _ref.selectedSuggestions,
      suggestions = _ref.suggestions,
      readOnly = _ref.readOnly,
      handleOnBlur = _ref.handleOnBlur,
      disableSelection = _ref.disableSelection,
      AutocompleteProps = _ref.AutocompleteProps,
      TextfieldInputProps = _ref.TextfieldInputProps,
      validationError = _ref.validationError,
      restprops = (0, _objectWithoutProperties2["default"])(_ref, ["fieldConfiguration", "dataElementSuffix", "handleOnAddNew", "addNewItemtext", "addNewCompare", "addNewValidator", "label", "multiSelect", "noItemFoundText", "onSelectionChange", "placeholder", "required", "selectedSuggestions", "suggestions", "readOnly", "handleOnBlur", "disableSelection", "AutocompleteProps", "TextfieldInputProps", "validationError"]);
  var memoizedValue = (0, _react.useMemo)(function () {
    var value = selectedSuggestions;

    if (!multiSelect && selectedSuggestions && selectedSuggestions.length === 1) {
      value = selectedSuggestions[0];
    }

    if (!multiSelect && (0, _isEmpty["default"])(value)) {
      // When we support multiple, autocomplete expects an empty array as value, so we cannot return null here
      return null;
    }

    return value;
  }, [selectedSuggestions]);
  (0, _react.useEffect)(function () {
    if (!selectedSuggestions) {
      return;
    }

    var getCompareLabel = function getCompareLabel(item) {
      return addNewCompare ? addNewCompare(item) : item[fieldConfiguration.label];
    }; // Copy selected items


    var selected = (0, _toConsumableArray2["default"])(selectedSuggestions); // Find the first newly added item

    var addedNewTemp = selected.find(function (i) {
      return i.addNew;
    });

    if (!addedNewTemp) {
      return;
    } // Get the label so we can compare if this is a new item which is not already in the list


    var addedNewTempLabel = getCompareLabel(addedNewTemp); // Check if we have an item in the list with the same label

    var addedNew = suggestions.find(function (option) {
      return getCompareLabel(option) === addedNewTempLabel;
    });

    if (addedNewTempLabel && addedNew) {
      // Ah, we found one! Lets find the index and replace it with the value from the suggestions
      var addedNewTempIndex = selected.map(function (option) {
        return getCompareLabel(option);
      }).indexOf(addedNewTempLabel);
      selected.splice(addedNewTempIndex, 1, addedNew);
      onSelectionChange(selected);
    }
  }, [suggestions.length, selectedSuggestions.length]);
  return _react["default"].createElement(FullWidthAutocomplete, (0, _extends2["default"])({
    disabled: readOnly || disableSelection,
    size: "small",
    multiple: multiSelect,
    options: suggestions || [],
    value: memoizedValue,
    noOptionsText: noItemFoundText,
    getOptionLabel: function getOptionLabel(option) {
      return option[fieldConfiguration.label] || option[fieldConfiguration.value];
    },
    getOptionSelected: function getOptionSelected(option, valueSelected) {
      return option[fieldConfiguration.value] === valueSelected[fieldConfiguration.value];
    },
    onChange: function onChange(event, value, reason, details) {
      var newItem;

      if (multiSelect && details && details.option && details.option.inputValue) {
        // Multiselect -> New item is available in details.option
        newItem = handleOnAddNew && handleOnAddNew(details.option.inputValue);
      } else if (value && value.inputValue) {
        // Single item mode, get from value object
        newItem = handleOnAddNew && handleOnAddNew(value.inputValue);
      }

      if (!value) {
        onSelectionChange([]);
      } else if (multiSelect) {
        // MultiSelect scenario. Delete the newly added item by MUI from the list
        // And our item (if present) from the handleOnAddNew function
        var newArr = value;

        if (newItem) {
          // Remove last item and add our returned value from handleOnAddNew
          newArr = value.slice(0, -1);
          newArr.push(newItem);
        }

        onSelectionChange(newArr);
      } else if (!value.inputValue) {
        onSelectionChange([value]);
      }
    },
    filterOptions: function filterOptions(options, params) {
      var filtered = filter(options, params);

      if (params.inputValue !== '' && handleOnAddNew) {
        // Check if we have a validator
        if (addNewValidator && addNewValidator(params.inputValue) === false) {
          return filtered;
        }

        var addText = "+ ".concat(params.inputValue);

        if (addNewItemtext) {
          addText = addNewItemtext(params.inputValue);
        }

        filtered.push((0, _defineProperty2["default"])({
          inputValue: params.inputValue,
          // Custom field so we can use this internal field to display in the options
          _addItemLabel: addText
        }, fieldConfiguration.label, params.inputValue));
      }

      return filtered;
    },
    renderOption: function renderOption(option) {
      var label = option._addItemLabel || option[fieldConfiguration.label] || option[fieldConfiguration.value];
      var secondaryLabel = option[fieldConfiguration.secondaryLabel];
      return _react["default"].createElement(_ListItemText["default"], {
        primary: label,
        secondary: secondaryLabel
      });
    },
    renderInput: function renderInput(params) {
      return _react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
        label: label,
        required: required,
        variant: "outlined",
        placeholder: placeholder,
        onBlur: handleOnBlur,
        autoComplete: "disabled",
        dataElementLocation: _taggingHelper.DataElementLocations.BODY,
        dataElementLabel: "control-autocomplete-multiselect-textfield-".concat(dataElementSuffix),
        dataElementId: "control-autocomplete-multiselect-textfield-".concat(dataElementSuffix),
        error: !!validationError,
        helperText: validationError
      }, params, {
        InputProps: (0, _objectSpread2["default"])({}, TextfieldInputProps, params.InputProps, {
          // Some logic to add our custom adornment.
          // Multiple on autocomplete (the tags) are using the adornments of the textfield
          // We need to merge our adornment and the tags adornment
          startAdornment: _react["default"].createElement(_react["default"].Fragment, null, TextfieldInputProps.startAdornment, params.InputProps.startAdornment)
        }),
        inputProps: (0, _objectSpread2["default"])({}, params.inputProps, {
          autoComplete: 'disabled'
        })
      }));
    }
  }, AutocompleteProps));
};

NewAutocomplete.propTypes = {
  dataElementSuffix: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  onSelectionChange: _propTypes["default"].func.isRequired,
  suggestions: _propTypes["default"].array.isRequired,

  /*
  * addNewItemtext={inputValue => `Add new item ${inputValue} to your list`}
  */
  addNewItemtext: _propTypes["default"].func,
  fieldConfiguration: _propTypes["default"].object,

  /**
   * Will be called when adding a new item.
   * Optional: you can return an object that will be used for the current selection
   */
  handleOnAddNew: _propTypes["default"].func,

  /**
   * You can pass a custom function to compare items when adding new ones
   */
  addNewCompare: _propTypes["default"].func,
  multiSelect: _propTypes["default"].bool,
  noItemFoundText: _propTypes["default"].string,
  placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  required: _propTypes["default"].bool,
  selectedSuggestions: _propTypes["default"].array,
  readOnly: _propTypes["default"].bool,
  handleOnBlur: _propTypes["default"].func,
  disableSelection: _propTypes["default"].bool,

  /**
   * Properties that will be passed onto the autocomplete component
   */
  AutocompleteProps: _propTypes["default"].object,

  /**
   * InputProps that will be passed to the TextField component
   */
  TextfieldInputProps: _propTypes["default"].object,
  validationError: _propTypes["default"].any,
  addNewValidator: _propTypes["default"].func // dataToLabelsMapping: PropTypes.object.isRequired, // Breaking change: Solved with custom ListItem and new fieldConfiguration object
  // disableTypeAhead: PropTypes.bool // Breaking change: not supported. I suggest using a normal dropdown for this, otherwise it is not a auto-complete
  // prefix: // Breaking change: Replaced with renderTags
  // Adornment: // Breaking change: Replaced with renderTags
  // mode: PropTypes.string: // Deprecated, is basically the same as multiSelect in the previous autocomplete
  // ignoreFields: PropTypes.array, // Deprecated property, not used anymore
  // ListItem: PropTypes.any, // Deprecated property, not used anymore. If needed, you can use the renderOption property
  // itemToString: PropTypes.func.isRequired, // Removed this

};
NewAutocomplete.defaultProps = {
  readOnly: false,
  fieldConfiguration: {
    label: 'label',
    secondaryLabel: 'secondaryLabel',
    value: 'value'
  },
  AutocompleteProps: {},
  TextfieldInputProps: {}
};
var _default = NewAutocomplete;
exports["default"] = _default;